/**
 * Central tool dispatch system
 * Routes canvas mouse events to the active tool handler
 */

import { Vec2 } from '@/canvas/coordinates';
import { EditorTool } from '@/core/stores/editor-store';

export interface ToolContext {
  worldPos: Vec2;
  screenPos: Vec2;
  shiftKey: boolean;
  ctrlKey: boolean;
  button: number; // 0=left, 1=middle, 2=right
}

export interface ToolHandler {
  onMouseDown?: (ctx: ToolContext) => void;
  onMouseMove?: (ctx: ToolContext) => void;
  onMouseUp?: (ctx: ToolContext) => void;
  onKeyDown?: (key: string, ctx: Partial<ToolContext>) => void;
  getCursor?: () => string; // CSS cursor
  renderPreview?: (ctx2d: CanvasRenderingContext2D, zoom: number, panOffset: Vec2) => void;
}

// Import all tool handlers
import { getSelectToolHandler } from './select-tool';
import { getPlaceToolHandler } from './place-tool';
import { getMoveToolHandler } from './move-tool';
import { getRotateToolHandler } from './rotate-tool';
import { getWallToolHandler } from './wall-tool';
import { getMeasureToolHandler } from './measure-tool';

/**
 * Get the handler for a specific tool
 */
export function getToolHandler(tool: EditorTool): ToolHandler {
  switch (tool) {
    case 'select':
      return getSelectToolHandler();
    case 'place':
      return getPlaceToolHandler();
    case 'move':
      return getMoveToolHandler();
    case 'rotate':
      return getRotateToolHandler();
    case 'wall_draw':
      return getWallToolHandler();
    case 'measure':
      return getMeasureToolHandler();
    case 'scale':
    case 'delete':
      // Not implemented yet
      return {};
    default:
      return {};
  }
}
